import {_utils, viewportChecker} from "../../../utils/_utils.js";

export const servicesBlock = () => {
    return new Promise((resolve, reject) => {
        _utils.initSection('.other-services', (section, sectionIndex) => init(section, sectionIndex));
        resolve();
    })
}

const init = (section, sectionIndex) => {

    const points = section.querySelectorAll('.other-services__services-list-item');
    const images = section.querySelectorAll('.other-services__services-item');
    const intervalTime = 10000;
    const slideLength = images.length;
    let counter = 0;
    let interval;
    let remainingTime = intervalTime;
    let lastSlideChangeTime;
    let isSliderActive = false;
    let firstTimeAnimation = true;
    let sectionInScreen = false;
    let clickPauseStatus = false;

    function updateProgress() {
        if (isSliderActive) {
            const elapsedTime = intervalTime - remainingTime + (Date.now() - lastSlideChangeTime);
            const progress = Math.min((elapsedTime / intervalTime) * 100, 100);
            images[counter].style.setProperty('--progress', `${progress}`);
        }
    }

    function slideChange() {
        counter = (counter + 1) % slideLength;
        images.forEach(item => {
            item.classList.remove('active');
            item.style.setProperty('--progress', '0'); // Скидаємо прогрес при зміні слайду
        });
        images[counter].classList.add('active');

        images.forEach(image => {
            image.querySelector('.other-services__services-item-status').classList.remove('running', 'paused');
        });
        points.forEach(item => {
            item.classList.remove('active');
        });
        points[counter].classList.add('active');
        images[counter].querySelector('.other-services__services-item-status').classList.add('running');

        lastSlideChangeTime = Date.now();
        remainingTime = intervalTime;
        startInterval();
    }

    function startInterval() {
        clearInterval(interval);
        interval = setInterval(slideChange, remainingTime);
        updateProgress();
        const progressInterval = setInterval(() => {
            updateProgress();
            if (!isSliderActive) clearInterval(progressInterval);
        }, 50);
    }

    function startSlider() {
        if (!isSliderActive && window.matchMedia("(min-width:1024px)").matches) {
            lastSlideChangeTime = Date.now();
            points[0].classList.add('active');
            images[0].classList.add('active');
            images[0].querySelector('.other-services__services-item-status').classList.add('running');
            startInterval();
            isSliderActive = true;

            points.forEach((tab, index) => {
                tab.addEventListener('click', (item) => {
                    counter = index;
                    if (!item.currentTarget.classList.contains('active')) {
                        clearInterval(interval);
                        remainingTime = intervalTime;
                        points.forEach(item => {
                            item.classList.remove('active');
                        });
                        tab.classList.add('active');
                        images.forEach(item => {
                            item.classList.remove('active');
                            item.style.setProperty('--progress', '0');
                            item.querySelector('.other-services__services-item-status').classList.remove('running', 'paused');
                        });
                        images[index].classList.add('active');
                        images[index].querySelector('.other-services__services-item-status').classList.add('running');
                        lastSlideChangeTime = Date.now();
                        remainingTime = intervalTime;
                        startInterval();
                        playSlider();
                    }
                });

                // Додаємо обробник кліку для .other-services__services-item-status
                const statusElement = images[index].querySelector('.other-services__services-item-status');
                if (statusElement) {
                    statusElement.addEventListener('click', () => {
                        if (isSliderActive) {
                            pauseSlider(index);
                            clickPauseStatus = true;
                        } else {
                            playSlider();
                            clickPauseStatus = false;
                        }
                    });
                }
            });
            firstTimeAnimation = false;
        } else {
            clearInterval(interval);
        }
    }

    function stopSlider() {
        if (isSliderActive) {
            clearInterval(interval);
            isSliderActive = false;
            points.forEach(item => {
                item.classList.remove('active');
            });
            images.forEach(item => {
                item.classList.remove('active');
                item.style.setProperty('--progress', '0');
                item.querySelector('.other-services__services-item-status').classList.remove('running', 'paused');
            });
        }
    }

    function pauseSlider(slideIndex) {
        if (isSliderActive) {
            if (typeof slideIndex === "number") {
                if (slideIndex === counter) {
                    images[counter].querySelector('.other-services__services-item-status').classList.remove('running');
                    images[counter].querySelector('.other-services__services-item-status').classList.add('paused');
                    clearInterval(interval);
                    remainingTime -= Date.now() - lastSlideChangeTime;
                    isSliderActive = false;
                }
            } else {
                images[counter].querySelector('.other-services__services-item-status').classList.remove('running');
                images[counter].querySelector('.other-services__services-item-status').classList.add('paused');
                clearInterval(interval);
                remainingTime -= Date.now() - lastSlideChangeTime;
                isSliderActive = false;
            }
        }
    }

    function playSlider() {
        if (!isSliderActive && window.matchMedia("(min-width:1024px)").matches) {
            images[counter].querySelector('.other-services__services-item-status').classList.remove('paused');
            images[counter].querySelector('.other-services__services-item-status').classList.add('running');
            lastSlideChangeTime = Date.now();
            startInterval();
            isSliderActive = true;
        }
    }

    function checkSliderStatus() {
        const sectionTop = section.getBoundingClientRect().top + window.scrollY;
        const sectionBottom = sectionTop + section.scrollHeight;
        const viewTop = window.scrollY;
        const viewBottom = viewTop + window.innerHeight;

        if (viewBottom > sectionTop && viewTop < sectionBottom) {
            if (firstTimeAnimation) {
                startSlider();
            } else if (!sectionInScreen) {
                pauseSlider();
            } else if (sectionInScreen && !clickPauseStatus) {
                playSlider();
            }
            sectionInScreen = true;
        } else {
            pauseSlider();
            sectionInScreen = false;
        }
    }

    function throttle(func, limit) {
        let inThrottle;
        return function() {
            if (!inThrottle) {
                func.apply(this, arguments);
                inThrottle = true;
                setTimeout(() => inThrottle = false, limit);
            }
        }
    }

    const throttledCheckSliderStatus = throttle(checkSliderStatus, 200);

    window.addEventListener('scroll', throttledCheckSliderStatus);
    window.addEventListener('resize', throttledCheckSliderStatus);

    checkSliderStatus();

}